import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Play from "./pages/Play/Play";
import Home from "./pages/Home/Home";
import Daily from "./pages/Daily/Daily";
import DailyAdmin from "./pages/Daily/DailyAdmin";
import { useEffect } from "react";
import { analyticsInit, identify, logPageView } from "./utils/analytics";
// Sets the language and loads every translation before anything is drawn.
import "./i18n";
function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    logPageView();
  }, [location]);
  return null;
}

function App() {
  useEffect(() => {
    analyticsInit("G-010X935NVR", "e76712f6b73362a8130bcb87b74f33b5");

    // Check for session ID immediately and then poll until it exists
    const checkForSessionId = () => {
      const sessionId = localStorage.getItem("fg_session_id");
      if (sessionId) {
        identify(sessionId);
        return true;
      }
      return false;
    };

    // If session ID doesn't exist immediately, start polling
    if (!checkForSessionId()) {
      const intervalId = setInterval(() => {
        if (checkForSessionId()) {
          clearInterval(intervalId);
        }
      }, 100); // Check every 100ms

      // Cleanup interval after 5 seconds if session ID never appears
      setTimeout(() => clearInterval(intervalId), 5000);
    }
  }, []);

  return (
    <Router>
      <RouteTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/play" element={<Play />} />
        <Route path="/daily" element={<Daily />} />
        <Route path="/daily/admin" element={<DailyAdmin />} />
      </Routes>
    </Router>
  );
}

export default App;
